import React from "react";
import { Icons } from "../../atoms/Icons";
import { Col, Row } from "react-bootstrap";
import "./messageModal.scss";
import docPdf from "../../assets/doc-pdf-purple.png";
import icnOpenDoc from "../../assets/open_doc.png";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/actions";
import LoadingSpinner from "../../atoms/Loader";
import NotFound from "../../atoms/NotFound";
import LabelText from "../../atoms/LabelText";
import { popupBlockerText } from "../../constants/constants";

const MessageModal = (props) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      month: "short",
      day: "2-digit",
      year: "numeric",
    };
    return date.toLocaleDateString("en-GB", options);
  };
  const date = formatDate(props?.data?.communication_datetime);
  const dispatch = useDispatch();
  const { getDocumentContent } = bindActionCreators(
    actionCreators,
    dispatch // eslint-disable-line
  );
  const { getDocumentFetching, getDocumentError } = useSelector(
    (state) => state.documentReducer); //eslint-disable-line
  const handleClick = async (attachmentId) => {
    try {
      const result = await getDocumentContent(props.investorId, attachmentId);
      const base64String = result?.documentData?.docContent;

      if (!base64String) {
        alert("Document content not found.");
        return;
      }

      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters, (char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      props.makeApiToInsertDocStatus(props.investorId, attachmentId);
      window.open(blobUrl, "_blank");
    } catch (error) {
      console.error("Error opening document:", error);
      alert("Failed to open document.");
    }
  };

  const formatText = (text) => {
    return text.replace(/\n/g, "<br />");
  };
  const hasAttachment =
    props?.data?.attachment_id &&
    props?.data?.attachment_id !== "" &&
    props?.data?.subject !== "Welcome to your new pension portal";
  return (
    <div className="message-modal-container">
      <div className="align-right">
        <span className="close me-2">
          <Icons
            iconname="close-large"
            variant="icon-twenty-four-px"
            clickHandler={props.handleCloseButton}
          />
        </span>
      </div>
      <div className="header d-flex me-5 mt-4">
        <Row>
          <Col>
            <Row>
              <span className="modal-title">{props?.modalTitle}</span>
            </Row>
            <Row>
              {/* //member type investor account ID needs to show */}
              <p className="drawdown">
                {props?.data?.account_id != "null"
                  ? props?.data?.account_id
                  : ""}{" "}
                {props?.data?.memberShipStatus}{" "}
                {props?.data?.account_id != "null" &&
                props?.data?.memberShipStatus != ""
                  ? props?.data?.membershipName
                    ? props?.data?.membershipName
                    : "No Employer Associated"
                  : ""}
              </p>
            </Row>
          </Col>
        </Row>
        <span className="align-right-text">
          <Row className="date-text">{date}</Row>
        </span>
      </div>
      <hr className="horizontal" />
      <div>
        <Row>
          <Col>
            <div
              className="ms-3 mb-2 me-2 description"
              dangerouslySetInnerHTML={{
                __html: formatText(props?.data?.body),
              }}
            />
          </Col>
        </Row>
      </div>
      <hr />
      {hasAttachment ? (
        <>
          <div className="attachments mb-2">Attachments</div>
          <Row>
            <Col>
              <div className="cards d-flex g-4">
                <span className="pdf-icon me-4 ms-2">
                  <img
                    src={docPdf}
                    alt="doc_pdf_image"
                    height={30}
                    width={30}
                    className="me-2"
                  />
                </span>
                <span className="attachment-name">
                  <Row>{props.data?.document_name}</Row>
                </span>
                <span
                  className="download-icon ms-4 me-2"
                  onClick={() => handleClick(props.data?.attachment_id)}
                >
                  <img
                    src={icnOpenDoc}
                    alt="open_doc_image"
                    width={20}
                    className="ms-2"
                  />
                </span>
              </div>
              <LabelText section="messages" text={popupBlockerText} />
            </Col>
          </Row>
        </>
      ) : (
        ""
      )}
      {getDocumentFetching ? <LoadingSpinner /> : ""}
      <br />
      {getDocumentError ? (
        <>
          <NotFound err={getDocumentError} />
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default MessageModal;
